import type { IElementID } from '@shared/models/project.model';

export const OPTIMISTIC_VERSION_ADDED_EVENT = 'nodon:optimistic-version-added';
export const OPTIMISTIC_VERSION_ADD_CANCELLED_EVENT =
  'nodon:optimistic-version-add-cancelled';

export type OptimisticVersionAddedEventDetail = {
  versionId: IElementID;
};

/**
 * Announces a locally-added version before navigation exposes it. Proposal
 * Overview uses this synchronous boundary to freeze the outgoing bars first.
 */
export const dispatchOptimisticVersionAdded = (versionId: IElementID) => {
  window.dispatchEvent(
    new CustomEvent<OptimisticVersionAddedEventDetail>(
      OPTIMISTIC_VERSION_ADDED_EVENT,
      { detail: { versionId } },
    ),
  );
};

export const dispatchOptimisticVersionAddCancelled = (
  versionId: IElementID,
) => {
  window.dispatchEvent(
    new CustomEvent<OptimisticVersionAddedEventDetail>(
      OPTIMISTIC_VERSION_ADD_CANCELLED_EVENT,
      { detail: { versionId } },
    ),
  );
};
